export default "__VITE_PUBLIC_ASSET__d636e869__"